import { render, staticRenderFns } from "./DrawerComparisonEditColumns.vue?vue&type=template&id=f2b255a6&scoped=true&"
import script from "./DrawerComparisonEditColumns.vue?vue&type=script&lang=js&"
export * from "./DrawerComparisonEditColumns.vue?vue&type=script&lang=js&"
import style0 from "./DrawerComparisonEditColumns.vue?vue&type=style&index=0&id=f2b255a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b255a6",
  null
  
)

export default component.exports